import React from 'react';
import styles from './space-menu-item.module.scss';

interface MenuItemProps {
  id: string;
  name: string;
  current: boolean;
  notifications?: number;
  icon: React.ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
}

export const SpaceMenuItem: React.FC<MenuItemProps> = ({
  id,
  name,
  notifications,
  current,
  icon,
  onClick,
  isDisabled,
}) => (
  <div
    className={styles['item']}
    id={id}
    data-disabled={isDisabled}
    data-active={current}
    onClick={onClick}
  >
    <div className={styles['icon']} data-current={current}>
      {icon}
    </div>

    <p className={styles['name']}>{name}</p>

    <span>{notifications && <div className={styles['notification']}>{notifications}</div>}</span>
  </div>
);
